import { Box } from '@mui/material';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function DelayScatter({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const scatterData = [{
        id: 'Members',
        data: data.map(d => ({
            x: d.avg_delay,
            y: d.total_volume / 1e6,
            name: d.name,
            trades: d.trades,
        })),
    }];

    return (
        <ChartSection
            id="delay-scatter"
            title="Who trades the most AND discloses the slowest?"
            subtitle="X = avg disclosure delay (days), Y = total trade volume ($M). Top-right = biggest traders who take longest to disclose."
        >
            <Box sx={{ height: 400 }}>
                <ResponsiveScatterPlot
                    data={scatterData}
                    margin={{ top: 20, right: 20, bottom: 60, left: 70 }}
                    xScale={{ type: 'linear', min: 0, max: 'auto' }}
                    yScale={{ type: 'linear', min: 0, max: 'auto' }}
                    nodeSize={8}
                    colors={[colors.primary]}
                    axisBottom={{
                        legend: 'Avg Disclosure Delay (days)',
                        legendPosition: 'middle',
                        legendOffset: 46,
                    }}
                    axisLeft={{
                        legend: 'Total Volume ($M)',
                        legendPosition: 'middle',
                        legendOffset: -55,
                        format: v => '$' + v + 'M',
                    }}
                    markers={[
                        {
                            axis: 'x',
                            value: 45,
                            lineStyle: { stroke: colors.error, strokeDasharray: '4 4' },
                            legend: '45-day STOCK Act deadline',
                            legendPosition: 'top',
                            textStyle: { fill: colors.error, fontSize: 10 },
                        },
                    ]}
                    tooltip={({ node }) => (
                        <ChartTooltip
                            title={node.data.name}
                            rows={[
                                {
                                    label: 'Avg delay',
                                    value: node.data.x + ' days',
                                    color: colors.primary,
                                },
                                {
                                    label: 'Volume',
                                    value: '$' + node.data.y.toFixed(1) + 'M',
                                },
                                {
                                    label: 'Trades',
                                    value: node.data.trades.toLocaleString(),
                                },
                            ]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
